// extracted by mini-css-extract-plugin
export default {"srOnly":"Ni5ucf"};